/* @flow */
import React from 'react';

import Footer from 'components/Footer';
import Column from 'components/UIKit/Flex/Column';

function CenteredLayout({
  children
}: Object): React.Element {
  return (
    <Column style={{
      flex: 1,
      backgroundColor: '#fafafa',
      alignItems: 'center',
      justifyContent: 'space-between',
      paddingTop: '.5rem',
      // for footer to stick in ie11
      minHeight: '100vh'}}
    >
      <Column style={{width: '74rem'}}>
      {children}
      </Column>
      <Footer />
    </Column>
  );
}

export default CenteredLayout;
